import React from 'react';

import { Button, createStyles, Drawer, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown } from '@tabler/icons-react';
import { InvoiceFilterControls, InvoiceFilterKey } from 'components/invoices/InvoiceFilterBar';
import { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';

// Same filter set as the desktop athlete invoices tab, minus the payment method
// column this view hides — the filter still applies, the column just isn't shown.
const FILTERS: InvoiceFilterKey[] = ['search', 'dueDateRange', 'status', 'autoPay', 'paymentMethods'];

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content min-content',
    gridTemplateAreas: `'title title title filters'`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
  },
  title: {
    gridArea: 'title',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.lg,
  },
  filters: {
    gridArea: 'filters',
  },
  button: {
    width: 'min-content',
    marginLeft: 'auto',
  },
}));

const AthleteInvoiceHeader = ({
  searchFilters,
  openTabsDrawer,
  setSearchFilters,
  initialSearchFiltersValue,
}: {
  searchFilters: InvoicesTableSearchFilters;
  openTabsDrawer: () => void;
  setSearchFilters: React.Dispatch<React.SetStateAction<InvoicesTableSearchFilters>>;
  initialSearchFiltersValue: InvoicesTableSearchFilters;
}): JSX.Element => {
  const { classes } = useStyles();

  const [isFiltersOpen, { open, close }] = useDisclosure(false);

  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
  };

  return (
    <div className={classes.header}>
      <Text size='md' fw='bold' className={classes.title} onClick={openTabsDrawer}>
        Invoices
        <IconChevronDown size={16} style={{ marginLeft: 4 }} />
      </Text>
      <Button onClick={open} className={classes.filters} size='xs'>
        Filters
      </Button>
      <Drawer position='bottom' opened={isFiltersOpen} onClose={close}>
        <Stack spacing='sm' justify='flex-start'>
          <Button color='red' onClick={handleClearFilters} className={classes.button}>
            Clear Filters
          </Button>
          <InvoiceFilterControls
            source='athlete-invoices-mobile'
            filters={FILTERS}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
            searchPlaceholder='Search by product name'
          />
        </Stack>
      </Drawer>
    </div>
  );
};

export default AthleteInvoiceHeader;
